module.exports = __webpack_public_path__ + "e4c381f30aa46573f317e2015ad6e108.svg";